/**
 * Maps widget class names (from the other platform) to display icons and colors
 * for the VideoWall widget menu.
 *
 * The class name comes from the custom widget's "class" field and determines
 * the visual representation in the toolbox sidebar.
 */

export const CLASS_ICON_MAP = {
  'Noise Pollution Control': { icon: '🔊', color: '#FF6B35' },
  'Air Pollution Control': { icon: '🌫️', color: '#4ECDC4' },
  'Bus Route': { icon: '🚌', color: '#45B7D1' },
  'Weather Service': { icon: '🌤️', color: '#96CEB4' },
  'Water Quality': { icon: '💧', color: '#4193F6' },
  'Energy Management': { icon: '⚡', color: '#FFD93D' },
  'Traffic Control': { icon: '🚦', color: '#FF6B6B' },
  'Waste Management': { icon: '♻️', color: '#6BCB77' },
  'Public Safety': { icon: '🛡️', color: '#9B59B6' },
  'Smart Lighting': { icon: '💡', color: '#F39C12' },
  'Parking Management': { icon: '🅿️', color: '#3498DB' },
  'Environmental Monitoring': { icon: '🌿', color: '#27AE60' },
};

export const DEFAULT_ICON = { icon: '📊', color: '#86BC25' };

/**
 * Get icon and color for a given widget class name.
 * Falls back to a default chart icon if the class is unknown.
 *
 * @param {string} className - The widget class (e.g., "Air Pollution Control")
 * @returns {{ icon: string, color: string }}
 */
export const getClassIcon = (className) => {
  return CLASS_ICON_MAP[className] || DEFAULT_ICON;
};

/**
 * Default grid dimensions for custom widgets when not explicitly specified.
 * These values determine the initial size when dragged onto the canvas.
 */
export const DEFAULT_WIDGET_DIMENSIONS = {
  w: 6,
  h: 8,
  minW: 3,
  minH: 4,
  maxW: 12,
  maxH: 24,
};
